import React from 'react';
import classNames from 'classnames';
import * as styles from './navigation.module.sass';
import { NavigationContainerProps } from './props.types';
import { Navigation } from '../../molecules/Navigation';
import { useMemo } from 'react';
import { useTranslation } from '../../../i18n/use-translation';

export const NavigationContainer = React.memo((props: NavigationContainerProps) => {
  const { t, locale } = useTranslation();
  const currentPath = window.location.pathname === '/' ? `/${locale}/patient` : window.location.pathname;

  const navigations = useMemo(() => {
    return props.titles.map((link: any, index: any) => (
      <Navigation
        key={`${link.href}-navigation-container`}
        href={link.href}
        title={link.title}
        size={props.size}
        nav_link={props.nav_link}
        liClassName={props.liClassName}
        active={currentPath === link.href}
      />
    ));
  }, [props.titles]);

  return (
    <>
      {props.label && <p className={styles.menu_modal_label}>{t('general_menu_title')}</p>}
      <ul
        className={classNames(
          styles.news_nav,
          { [styles.news_nav_desktop_display]: props.desktop_display },
          { [styles.news_nav_mobile_display]: props.mobile_display },
          { [styles.news_nav_laptop_mobile_display]: props.mobile_laptop_display },
          { [styles.news_nav_laptop_display]: props.laptop_display },
          props.className,
        )}
      >
        {navigations}
      </ul>
    </>
  );
});
